import React, { useState, useEffect } from 'react'
import { Layout, Menu, Drawer, Button } from 'antd'
import {
  DashboardOutlined,
  DesktopOutlined,
  FileTextOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined
} from '@ant-design/icons'
import { useTheme } from '../contexts/ThemeContext'
import './Sidebar.css'

const { Sider } = Layout

const Sidebar = ({ visible, onClose, onMenuClick }) => {
  const { currentTheme } = useTheme()
  const [collapsed, setCollapsed] = useState(false)
  const [isMobile, setIsMobile] = useState(false)

  // Detectar se é mobile
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }

    checkMobile()
    window.addEventListener('resize', checkMobile)

    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  // Fechar sidebar mobile quando a tela for redimensionada para desktop
  useEffect(() => {
    if (!isMobile && visible) {
      onClose && onClose()
    }
  }, [isMobile, visible, onClose])

  // Emitir evento quando sidebar colapsa/expande
  useEffect(() => {
    const event = new CustomEvent('sidebarToggle', {
      detail: { collapsed }
    })
    window.dispatchEvent(event)
  }, [collapsed])

  const menuItems = [
    {
      key: 'operacional',
      icon: <DashboardOutlined style={{ color: '#1890ff', fontSize: '28px' }} />,
      label: <span className="sidebar-menu-label">Operacional</span>,
    },
    {
      key: 'expedicao',
      icon: <DesktopOutlined style={{ color: '#52c41a', fontSize: '28px' }} />,
      label: <span className="sidebar-menu-label">Expedição</span>,
    },
    {
      key: 'relatorios',
      icon: <FileTextOutlined style={{ color: '#fa8c16', fontSize: '28px' }} />,
      label: <span className="sidebar-menu-label">Relatórios</span>,
    },
  ]

  const handleMenuClick = (menuInfo) => {
    if (onMenuClick) {
      onMenuClick(menuInfo)
    }
    // Fechar sidebar em mobile após clique
    if (isMobile && onClose) {
      onClose()
    }
  }

  const sidebarContent = (
    <div className="sidebar-content">
      <div className="sidebar-header">
        {!collapsed && !isMobile && (
          <div className="sidebar-title">
            Menu
          </div>
        )}
        {!isMobile && (
          <Button
            type="text"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
            className="sidebar-toggle"
          />
        )}
      </div>

      <Menu
        mode="inline"
        items={menuItems}
        onClick={handleMenuClick}
        className="sidebar-menu"
        theme={currentTheme === 'dark' ? 'dark' : 'light'}
      />
    </div>
  )

  // Renderizar como Drawer em mobile
  if (isMobile) {
    return (
      <Drawer
        title="Menu Operacional"
        placement="left"
        onClose={onClose}
        open={visible}
        className={`sidebar-drawer ${currentTheme}`}
        width={120}
      >
        {sidebarContent}
      </Drawer>
    )
  }

  // Renderizar como Sider em desktop
  return (
    <Sider
      trigger={null}
      collapsible
      collapsed={collapsed}
      className={`sidebar-desktop ${currentTheme}`}
      width={110}
      collapsedWidth={40}
      style={{
        position: 'fixed',
        height: 'calc(100vh - 25px)',
        left: 0,
        top: 32,
        zIndex: 100,
        overflow: 'auto'
      }}
    >
      {sidebarContent}
    </Sider>
  )
}

export default Sidebar
